{
  "caregivers": "auxiliaires",
  "caregiver": "auxiliaire",
  "caregivers_full": "auxiliaires de vie",
  "caregiver_full": "auxiliaire de vie",
  "caregiver_short": "AVS",
  "company_name": "Ouihelp",
  "holiday_not_worked_label": "1er mai"
}
